module.exports = __webpack_public_path__ + "static/decanter_of_endless_water_mtg_clb-79c401ee0ae3cfd4257e2bd59d902f83.webp";